import { useRef } from 'react';
import Button from 'components/Button';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

const TEXT_FIELDS = [
    ['leadImageAlt', 'Alt text (required)', 255, 'What the picture shows'],
    ['leadImageCaption', 'Caption', 500, ''],
    ['leadImageCredit', 'Credit', 255, 'Photo: Reuters'],
];

// The picture above the story, and the one Google and social cards show. The
// file uploads straight away; alt, caption, credit and Remove save with the story.
const LeadImageFields = ({ story, draft, uploading, onChange, onUpload }) => {
    const fileInput = useRef(null);
    const current = story?.leadImageUrl && !draft.clearLeadImage;

    return (
        <fieldset className={styles.faqOffer}>
            <legend className={styles.kicker}>Lead image</legend>
            <p className={styles.hint}>
                Shown under the byline and on Google and social media. PNG, JPEG
                or WebP, at least 1200px wide and 675px tall, up to 10 MB. Write
                the alt text before choosing the file.
            </p>
            {current && (
                <img
                    className={styles.leadImagePreview}
                    src={story.leadImageUrl}
                    alt={story.leadImageAlt || ''}
                />
            )}
            {story?.leadImageUrl && draft.clearLeadImage && (
                <p className={styles.hint}>
                    The lead image is removed when you save.
                </p>
            )}
            {TEXT_FIELDS.map(([name, label, maxLength, placeholder]) => (
                <div key={name}>
                    <label className={styles.label} htmlFor={`story-${name}`}>
                        {label}
                    </label>
                    <input
                        id={`story-${name}`}
                        className={styles.input}
                        value={draft[name]}
                        maxLength={maxLength}
                        placeholder={placeholder}
                        onChange={(e) => onChange(name, e.target.value)}
                    />
                </div>
            ))}
            <input
                ref={fileInput}
                type="file"
                accept="image/png,image/jpeg,image/webp"
                hidden
                onChange={(e) => {
                    const [file] = e.target.files;
                    // So picking the same file again after an error uploads it again.
                    e.target.value = '';
                    if (file) onUpload(file);
                }}
            />
            <div className={styles.leadImageActions}>
                <Button
                    theme={'primary'}
                    title={current ? 'Replace image' : 'Upload image'}
                    loading={uploading}
                    disabled={!draft.leadImageAlt.trim()}
                    onClick={() => fileInput.current?.click()}
                />
                {story?.leadImageUrl && (
                    <Button
                        theme={'secondary'}
                        title={draft.clearLeadImage ? 'Keep image' : 'Remove'}
                        onClick={() =>
                            onChange('clearLeadImage', !draft.clearLeadImage)
                        }
                    />
                )}
            </div>
        </fieldset>
    );
};

export default LeadImageFields;
